// extracted by mini-css-extract-plugin
module.exports = {"slidecontainer":"styles_slidecontainer__WQCQG","timboxContainer":"styles_timboxContainer__31U28","sliderRange":"styles_sliderRange__1sTvl"};